
<template>
    
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 姓名｜郵箱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
                    <el-button  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加機器人</el-button>
					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button>
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="姓名" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索姓名"></el-input>
						</el-form-item>
						
						<el-form-item label="郵箱" class="mb-0">
							<el-input size="small" v-model="from.email" placeholder="搜索郵箱"></el-input>
						</el-form-item>

						<el-form-item label="編號" class="mb-0">
							<el-input size="small" v-model="from.uid" placeholder="搜索編號"></el-input>
						</el-form-item>

						<el-form-item label="年級">
							<el-select v-model="from.grade_id" size="small"  placeholder="請選擇" style="width: 85%;">
								<el-option :key="-1" label="全部" :value="-1"></el-option>
								<el-option v-for="item in grade_list" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>


						<el-form-item label="年級" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="普通郵箱" :value="1"></el-option>
								<el-option label="題目反饋" :value="2"></el-option>
							</el-select>
						</el-form-item>
					
						<el-form-item label="創建時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>
        

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">
				</el-table-column>

				<el-table-column align="center" width="80" prop="user_no" label="編號">
				</el-table-column>
                	
				<el-table-column align="center" prop="email" label="郵箱">
				</el-table-column>
                
				<el-table-column align="center" prop="name" label="姓名">
				</el-table-column>

                <el-table-column align="center" prop="username" label="暱稱">
				</el-table-column>
				
				<el-table-column align="center" prop="name_en" label="英文姓名">
				</el-table-column>

				<el-table-column align="center" prop="grade_name" label="年級">
				</el-table-column>
				
                <el-table-column align="center" prop="head" label="頭像">
					<template slot-scope="scope">
						<el-image 
						    style="width: 40px; height: 40px"
						    :src="scope.row.head" 
						    :preview-src-list="check_img_list">
						  </el-image>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="create_time" width="200" label="創建時間">
				</el-table-column>
				
                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button @click="openModel(scope.row)"  v-auth="'edit'+auth_val"  size="mini" plain type="primary">操作</el-button>
							<el-button @click="deleteItem(scope.row)"  v-auth="'del'+auth_val"  size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  title="機器人" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form  :rules="rulesUser" ref="formEdit" :model="formUser" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
                <el-form-item label="郵箱" prop="email">
					<el-input type="text"  v-model="formUser.email" 
					placeholder="郵箱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="姓名" prop="name">
					<el-input type="text"  v-model="formUser.name" 
					placeholder="姓名" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="姓名（英文）" prop="name_en">
					<el-input type="text"  v-model="formUser.name_en" 
					placeholder="姓名（英文）" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="性別">
					<el-radio-group v-model="formUser.sex">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item label="暱稱" prop="username">
					<el-input type="text"  v-model="formUser.username" 
					placeholder="暱稱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
                
                <el-form-item label="年級"  prop="grade_id">
					<el-select v-model="formUser.grade_id">
						<el-option
						v-for="item in grade_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="密碼" prop="password">
					<el-input type="text"  v-model="formUser.password" 
					placeholder="密碼" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="userSubmit">確 定</el-button>
			</div>
		</el-dialog>


		<el-dialog :close-on-click-modal="false"  title="添加機器人" :visible.sync="createRobotModel" 
		top="5vh" :width="layout.is_phone?'90%':'60%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				<el-form-item label="年級"  prop="grade_id">
					<el-select  v-model="form.grade_id">
						<el-option
						v-for="item in grade_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="創建個數" prop="num">
					<el-input type="number" v-model="form.num" 
					placeholder="創建個數" 
					clearable size="small" style="width: 85%;">
					</el-input>
				</el-form-item>

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createRobotModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

		

	</div>
</template>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
                type:'1',

				createModel: false,
				createRobotModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					email: '',
					uid: '',
					type: -1,
					status: -1,
					time: [],
				},
				model_title: 'Robot',
				auth_val: 'Robot',
				preUrl: "data/RobotList", //列表地址
				delAllUrl: "data/delRobotAll", //批量删除地址
                addUrl: "data/addRobot", //添加/修改地址
				delUrl: "data/delRobot", //删除單条地址

				tableData: [],
				form: {
					num: 0,
					grade_id: 1,
				},

				formUser: {
						id: 0,
						name:'',
						sex:1,
						name_en:'',
						username:'',
						grade_id:'',
						class_id:'',
						number:'',
						email:'',
						phone:'',
                        password: '',
				},

				rulesUser: {
					name: [{
							required: true,
							message: "姓名不能為空",
							trigger: 'blur',
						},
					],
					
					username: [{
							required: true,
							message: "暱稱不能為空",
							trigger: 'blur',
						},
					],
					email: [{
							required: true,
							message: "郵箱不能為空",
							trigger: 'blur',
						},
					],
					
					grade_id: [{
							required: true,
							message: "請選擇年級",
							trigger: 'blur',
						},
					],
					
				},

				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],

                grade_list: [],
				rules: {
                    num: [
                        {
                        required: true,
                        message: "請輸入需要創建的機器人數量",
                        trigger: 'blur',
                        },
                        {
                        validator: (rule, value, callback) => {
                            if (value <= 0) {
                            callback(new Error("機器人數量必須大於0")); // 自定义错误提示
                            } else {
                            callback(); // 验证通过
                            }
                        },
                        trigger: 'blur',
                        }
                    ],
				},

			}
		},
        created() {
			this.commonList(['grade_list']);
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		methods: {
			
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				this.$refs.form.validate(res => {
					if (res) {
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
                        this.createRobotModel = false
						// 關閉模态框
					}
				})
			},

				//提交
			userSubmit() {
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						this.formUser.id = this.editIndex
						this.addOrEdit(this.formUser)
                        this.createRobotModel = false
						// 關閉模态框
					}
				})
			},
			
            //公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.grade_list = list.grade
					if (this.grade_list.length > 0) {
						// 设置默認选中项为subject_list中的第一个元素
						this.form.grade_id = this.grade_list[0].id;
					}
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},

			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				// 修改
				if(e){
					this.formUser = {
						id:  e.id,
						name: e.name,
						name_en: e.name_en,
						username:e.username,
						grade_id:e.grade_id,
						school_id:e.school_id,
						diamond:e.diamond,
						coin:e.coin,
						class_id:e.class_id,
						sex:e.sex,
						number:e.number,
						email:e.email,
						str_school:e.str_school,
						type:e.type,
                        password: '',
					}
					this.editIndex = e.id
					this.createModel = true
				}else{
					
					this.editIndex = -1
					this.createRobotModel = true
				}
				
				// 打开dialog
				
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					email: '',
					uid: '',
					type: -1,
					status: -1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
